
exports.shouldUpdateScroll = () => {
  return [0, 0];
};

exports.onInitialClientRender = () => {
  window.scrollTo(0, 0);
};
